"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var clsx_1 = __importDefault(require("clsx"));
var Text_1 = require("./Text");
var colors_1 = require("../colors");
var useStyles = (0, styles_1.makeStyles)(function () { return ({
    base: {
        backgroundColor: 'transparent',
        border: 'none',
        boxShadow: 'none',
        color: (0, colors_1.getColor)('DARK_PURPLE_100'),
        cursor: 'pointer',
        width: 'fit-content',
        '&:hover': {
            color: (0, colors_1.getColor)('PURPLE_100'),
        },
    },
}); });
var Link = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick;
    var classes = useStyles();
    return (react_1.default.createElement("button", { className: (0, clsx_1.default)(classes.base, className), onClick: onClick, type: 'button' },
        react_1.default.createElement(Text_1.Text, { variant: 'bodySemibold' }, children)));
};
exports.Link = Link;
